import { useState, type ReactNode } from "react";

/** Ein Knopf, der während seiner Aktion gesperrt ist — kein doppeltes Absenden. */
export function BusyButton({ onClick, className = "pf-btn", disabled = false, title, children }: {
  onClick: () => Promise<unknown> | void;
  className?: string;
  disabled?: boolean;
  title?: string;
  children: ReactNode;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button" className={className} disabled={disabled || busy} title={title}
      onClick={async (e) => {
        e.preventDefault();
        if (busy) return;
        setBusy(true);
        try { await onClick(); } finally { setBusy(false); }
      }}
    >{children}</button>
  );
}
